import { SxProps } from '@mui/material';

export const accordion: SxProps = {
  boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)',
  borderRadius: '8px',

  '&.MuiAccordion-root:before': {
    display: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: '#ffffff',
  },
};
